import { createResource } from "~/lib/resourceFactory";
import { getBankAccount, listBankAccounts } from "./bank-account.api";

type BankAccountsPage = Awaited<ReturnType<typeof listBankAccounts>>;
type BankAccountDetail = Awaited<ReturnType<typeof getBankAccount>>;

export type BankAccountsParams = {
  businessId: string;
  search?: string;
  offset?: number;
  limit: number;
  ids?: string[];
};

export type BankAccountDetailParams = { businessId: string; id: string };

export const BankAccountResource = createResource<
  BankAccountsPage,
  BankAccountsParams
>({
  key: (p) =>
    [
      "bank-account",
      p.businessId,
      p.limit,
      p.search ?? "",
      p.offset ?? 0,
      p.ids === undefined ? "*" : p.ids.join(","),
    ] as const,
  fetcher: (p) =>
    listBankAccounts({
      data: {
        businessId: p.businessId,
        search: p.search,
        offset: p.offset,
        limit: p.limit,
        ids: p.ids,
      },
    }),
});

export const BankAccountDetailResource = createResource<
  BankAccountDetail,
  BankAccountDetailParams
>({
  key: ({ businessId, id }) => ["bank-account", businessId, id] as const,
  fetcher: ({ businessId, id }) => getBankAccount({ data: { businessId, id } }),
});
